import { cn } from '@/shared/lib'
import type { Excursion } from '../model/schema'

interface OccupancyProps {
  excursion: Excursion
  className?: string
}

/**
 * Занятость выхода числом — только внутри кабинета. Наружу (`booking`) уходит
 * лишь «есть места / мест не осталось», без чисел: `PublicExposure`.
 */
export function Occupancy({ excursion, className }: OccupancyProps) {
  const { seatsTaken, capacity } = excursion
  const over = capacity !== null && seatsTaken > capacity
  return (
    <span
      className={cn('mono-num text-xs', over ? 'text-warning' : 'text-text-secondary', className)}
      title={over ? 'Мест занято больше вместимости — это допустимо' : undefined}
    >
      {capacity === null ? `${seatsTaken} мест` : `${seatsTaken}/${capacity}`}
    </span>
  )
}
